import { ContainerModule } from 'inversify';
import notificationStoreModule from './notification-store-module'
import { NotificationStoreModuleSymbol } from './symbol';

export const notificationStateModule = new ContainerModule((bind) => {
  bind(NotificationStoreModuleSymbol).toConstantValue(notificationStoreModule);
})
